import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout as authLogout } from "../../oauth";
import { IApplicationState } from "../../state/ducks";
import { accessCleared } from "../../state/ducks/access";
import { AuthReducerState, logoutAsync } from "../../state/ducks/auth";
import { clearActivity } from "../../state/utils/activity";
import { APP_VERSION } from "../../config";
import { configContext } from "../config-provider";

interface NavbarProps {}

export const Navbar: React.FC<NavbarProps> = (props) => {
  const dispatch = useDispatch();
  const { authServer } = React.useContext(configContext);
  const auth = useSelector<IApplicationState, AuthReducerState>((state) => state.auth);
  const [busy, setBusy] = React.useState(false);

  const handleLogout = async () => {
    if (busy) return;
    setBusy(true);
    // End the session on the auth server first. Clearing localStorage alone
    // leaves the token valid until it expires and keeps the session in the
    // feed, so anyone holding a copy stays signed in.
    if (auth.token.accessToken) {
      await authLogout(authServer, auth.token.accessToken);
    }
    // Local state is cleared whatever the server said — a network failure
    // must not trap the user in a session they asked to leave.
    clearActivity();
    dispatch(accessCleared());
    dispatch(logoutAsync());
    setBusy(false);
  };

  return (
    <nav className="portal-navbar">
      <h1 className="brand">EMMS</h1>
      {/*
        A third flex child, safe here because .avatar is absolutely positioned
        and so is not part of the flow. Aligned to the baseline of the 64px
        brand rather than centred, which would leave it floating mid-header.
      */}
      <span className="app-version" title="Client version">
        v{APP_VERSION}
      </span>
      <span className="avatar" aria-label="logout" onClick={handleLogout}>
        {busy ? "Logging out…" : "Logout"}
      </span>
    </nav>
  );
};
